import HomeService from "@/services/HomeService";

const getDefaultState = () => {
    return {
        home: [],
    };
};

export default {
    state: () => getDefaultState(),
    getters: {
        getHome: state => state.home,
    },
    mutations: {
        setHome: (state, home) => {
            state.home = home;
        },
        setHomeState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        processHome: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await HomeService.get();
                commit("setHome", response.data);
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetHomeState: ({ commit }) => {
            commit("setHomeState");
        },
    },
};
